import { KIO, KK, OutputMode, SetMagnetSenior, VK } from '@hid/define/define'
import { kkFromVK, vkFromKK } from '@hid/define/define_fn'
import { defaultVK } from '@hid/define/define_keys'
import { deviceMap } from '@hid/define/define_list'
import { PostMagnetSetSeniorKey } from '@hid/define/request'
import { deviceManager } from '@hid/device/device_manager'
import { DataProfile, dataProfileManage } from '@hid/snapshot/profile'
import { MagnetSeniorType } from '@libs/types/enum'

export async function HandleSetMagnetSeniorkey(data: PostMagnetSetSeniorKey) {
  const config = dataProfileManage().dataProfile
  clearMagnetSeniorkey(config)
  markKmeKeys(data.Key, data.Value.KeyType, config, data.IsFn, data.Value.Keys[0].KeyCode[0] as VK)

  addSeniorKey(config, data)
  if (data.Value.KeyType == MagnetSeniorType.SeniorKeyTypeKME) {
    bindKey(MagnetSeniorType.SeniorKeyTypeKME, config, data)
  }

  if (data.Value.KeyType == MagnetSeniorType.SeniorKeyTypeRS) {
    bindKey(MagnetSeniorType.SeniorKeyTypeRS, config, data)
  }

  dataProfileManage().save()

  if (deviceManager.deviceDriver.magnet == undefined) {
    throw new Error('Device driver is not found')
  }
  await deviceManager.deviceDriver.magnet?.syncSeniorkey()
}

// 当kme 和 rs 类型时，需要绑定一个键
const bindKey = (type: MagnetSeniorType, config: DataProfile, data: PostMagnetSetSeniorKey) => {
  const kk = kkFromVK(data.Value.Keys[0].KeyCode[0] as VK, deviceManager.deviceID)
  if (kk == undefined) {
    throw new Error('bindKK is not found')
  }
  const key = vkFromKK(data.Key, deviceManager.deviceID)
  const kmeMode: [number, number] = type == MagnetSeniorType.SeniorKeyTypeKME ? [data.Value.KMEMode[1], data.Value.KMEMode[0]] : [0, 0]
  const setData: PostMagnetSetSeniorKey = {
    Key: kk,
    IsFn: data.IsFn,
    Value: {
      KeyType: type,
      Keys: [
        { KeyCode: [key, 0, 0], KeyFunction: [0, 0, 0, 0], Travel: 0 },
        { KeyCode: [0, 0, 0], KeyFunction: [0, 0, 0, 0], Travel: 0 },
        { KeyCode: [0, 0, 0], KeyFunction: [0, 0, 0, 0], Travel: 0 },
        { KeyCode: [0, 0, 0], KeyFunction: [0, 0, 0, 0], Travel: 0 },
      ],
      MTDuration: 0,
      TGLEnable: 0,
      TGLMode: 0,
      KMEMode: kmeMode,
      DelayTime: data.Value.DelayTime,
    },
  }
  //markKmeKeys(kk, data.Value.KeyType, data.IsFn, key as VK)
  addSeniorKey(config, setData)
}

function addSeniorKey(config: DataProfile, data: PostMagnetSetSeniorKey) {
  const index = getSeniorDataIndex(config.MagnetData)
  config.MagnetData.set(index, data.Value)
  config.Keys = config.Keys.filter((item) => item.Input.KK != data.Key || (item.Input.KK == data.Key && item.Input.WithFN != data.IsFn))
  const mapkey: KIO = {
    Input: {
      KK: data.Key,
      WithFN: data.IsFn,
      WithModifier: [],
    },
    Output: {
      VK: defaultVK,
      Mode: OutputMode.Magnet,
      DataIndex: index,
      Extension: [],
    },
  }
  config.Keys.push(mapkey)
}

function getSeniorDataIndex(data: Map<number, SetMagnetSenior>) {
  const len = deviceMap[deviceManager.deviceID].support.Limit.MagnetLen
  for (let index = 0; index < len; index++) {
    if (!data.has(index)) {
      return index
    }
  }
  throw new Error('Senior data is full')
}

function clearMagnetSeniorkey(config: DataProfile) {
  config.MagnetData.forEach((_, key) => {
    const index = config.Keys.findIndex((v) => {
      return v.Output.Mode == OutputMode.Magnet && v.Output.DataIndex == key
    })
    if (index < 0) {
      config.MagnetData.delete(key)
    }
  })
}

// 如果当前设置的按键已经绑定过kme，删除旧的kme存档，标记绑定的键。
export function markKmeKeys(kk: KK, type: MagnetSeniorType, config: DataProfile, isFn: boolean, bindVK?: VK) {
  if ((kk as any) === -1) return
  markKmeBind(kk, isFn, config, bindVK)
  if (type == MagnetSeniorType.SeniorKeyTypeKME || type == MagnetSeniorType.SeniorKeyTypeRS) {
    const bindKK = kkFromVK(bindVK as VK, deviceManager.deviceID)
    if (bindKK == undefined) {
      throw new Error('bindKK is not found')
    }
    const bindKey = vkFromKK(kk, deviceManager.deviceID)
    markKmeBind(bindKK, isFn, config, bindKey)
  }
}

function markKmeBind(kk: KK, isFn: boolean, config: DataProfile, bindVK?: VK) {
  const currentKey = config.Keys.find((item) => item.Input.KK == kk)
  if (currentKey && currentKey.Output.Mode == OutputMode.Magnet) {
    const magnetData = config.MagnetData.get(currentKey.Output.DataIndex)
    if (magnetData && (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeKME || magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeRS)) {
      if (magnetData.Keys[0].KeyCode[0] == bindVK) {
        // 设的是同一对键，不做处理
        return
      }

      const bindKK = kkFromVK(magnetData.Keys[0].KeyCode[0] as VK, deviceManager.deviceID)
      const bindKey = config.Keys.find((item) => item.Input.KK == bindKK && item.Input.WithFN == isFn)
      if (bindKey) {
        dataProfileManage().ResetKmeKeys.push(bindKey)
        config.MagnetData.delete(bindKey.Output.DataIndex)
        config.Keys = config.Keys.filter((item) => item.Input.KK != bindKey.Input.KK || (item.Input.KK == bindKey.Input.KK && item.Input.WithFN != isFn))
      }
    }
  }
}
